import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Contract } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contract.model';
import * as fromContractsAction from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/actions/contracts.action';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface State extends EntityState<Contract> {
  selectedContractId: number | null;
}

export const adapter: EntityAdapter<Contract> = createEntityAdapter<Contract>({
  selectId: ($contract: Contract) => $contract.salesDocumentId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedContractId: null,
});

export function reducer(state = initialState, action: fromContractsAction.Actions | OrderBuilderActions): State {
  switch (action.type) {
    case fromContractsAction.ActionTypes.ADD_CONTRACTS: {
      return adapter.addMany(action.payload.contracts, { ...state });
    }
    case RESET_BUILDER:
    case fromContractsAction.ActionTypes.CLEAR_CONTRACTS: {
      return adapter.removeAll(state);
    }
    case fromContractsAction.ActionTypes.FETCH_CONTRACTS:
    case fromContractsAction.ActionTypes.NO_ACTION:
    default: {
      return state;
    }
  }
}

export const getEntities = (state: State) => state.entities;

export const getContracts = (state: State) => {
  const contracts: Contract[] = Object.keys(state.entities).map(i => state.entities[i]);
  return contracts;
};
